import * as Api from './api'
import { Accomodation } from './types'

declare var I18n : { locale: string, t: (_:string) => string }

const getLoadingDiv = () : HTMLDivElement => {
  const div = document.createElement("div");
  div.className = 'marker__callout__loading';
  const span = document.createElement("span");
  span.innerHTML = I18n.t('search.infowindow.loading');

  div.appendChild(span)
  return div;
}

const accommodationCallout = (accommodation: Accomodation, getUrl: (_: Accomodation) => string) : mapkit.AnnotationCalloutDelegate => {
  return {
    calloutElementForAnnotation: (_annotation) : HTMLDivElement => {
      const div = document.createElement("div");
      div.className = 'marker__callout';
      div.appendChild(getLoadingDiv())
      Api.fetchAccommodationMapsSnippet(getUrl(accommodation)).then(text => div.innerHTML = text)
      return div;
    },

    calloutAnchorOffsetForAnnotation: (_annotation, _element) : DOMPoint => {
      return new DOMPoint(0, 0);
    },

    calloutAppearanceAnimationForAnnotation: (_annotation) : string => {
     return "scale-and-fadein .4s 0 1 normal cubic-bezier(0.4, 0, 0, 1.5)";
    },
  };
}

export const getAccommodationAnnotation = (
  accommodation: Accomodation,
  getUrl: (_: Accomodation) => string,
  className: string,
  callout: boolean
) : mapkit.Annotation => {
  const coord = new mapkit.Coordinate(parseFloat(accommodation.lat), parseFloat(accommodation.lng))

  const annotation = new mapkit.Annotation(coord, (_coordinate, _options) => {
    const div = document.createElement("div");
    div.textContent = ``;
    div.className = `applemaps_accommodation ${className}`;
    return div;
  }, {
    anchorOffset: new DOMPoint(0, 0),
    callout: callout ? accommodationCallout(accommodation, getUrl) : null
  });

  annotation.data.accommodation = accommodation;

  return annotation;
}

export const getClusterAnnotation = (cluster: Accomodation) : mapkit.Annotation => {
  const coord = new mapkit.Coordinate(parseFloat(cluster.lat), parseFloat(cluster.lng))
  const annotation = new mapkit.Annotation(coord, (_coordinate, _options) => {
      const div = document.createElement("div");
      div.textContent = `${cluster.size}`;
      div.className = "applemaps_cluster";
      return div;
  }, {
    anchorOffset: new DOMPoint(0, -25)
  });

  annotation.data.accommodation = cluster

  return annotation;
}
